export default __webpack_public_path__ + "static/media/Rshinpad.26b67325.svg";